/**
 * @generated
 * This file was automatically generated and should not be manually edited.
 *
 * Auto-generated enum for: configurations.config_name
 *
 * To regenerate: npm run db:codegen
 * Any manual changes will be overwritten on next generation.
 */

/* eslint-disable */
// @ts-nocheck

/**
 * ConfigurationConfigName enum representing allowed values for configurations.config_name
 */
export enum ConfigurationConfigName {
  /** Board Template Defaults */
  BOARD_TEMPLATE_DEFAULTS = 'board_template_defaults',
}
